const BalanceToastMsg = {
  /**
   *  [정산 리스트] 정산 리스트 엑셀 다운로드 요청하기
   */
  GET_BALANCE_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '정산 리스트 엑셀 다운로드 요청하기 성공',
  GET_BALANCE_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '정산 리스트 엑셀 다운로드 요청하기 실패',

  /**
   * [정산 리스트] 정산 아이템 리스트 엑셀 다운로드 요청하기
   */
  GET_BALANCE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '정산 아이템 리스트 엑셀 다운로드 요청하기 성공',
  GET_BALANCE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '정산 아이템 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [정산 상세] 정산 상세 요청하기
   */
  GET_BALANCE_DETAIL_REQUEST_SUCCESS: '정산 상세 요청하기 성공',
  GET_BALANCE_DETAIL_REQUEST_ERROR: '정산 상세 요청하기 실패',

  /**
   *  [정산 상세] 정산 업데이트 요청하기
   */
  EDIT_BALANCE_DETAIL_REQUEST_SUCCESS: '정산 상세 업데이트 요청하기 성공',
  EDIT_BALANCE_DETAIL_REQUEST_ERROR: '정산 상세 업데이트 요청하기 실패',

  /**
   *  [정산 브랜드 리스트] 정산 브랜드 리스트 요청하기
   */
  GET_BALANCE_BRAND_LIST_REQUEST_SUCCESS: '정산 브랜드 리스트 요청하기 성공',
  GET_BALANCE_BRAND_LIST_REQUEST_ERROR: '정산 브랜드 리스트 요청하기 실패',

  /**
   *  [정산 브랜드 리스트] 정산 브랜드 리스트 엑셀 다운로드 요청하기
   */
  GET_BALANCE_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '정산 브랜드 리스트 엑셀 다운로드 요청하기 성공',
  GET_BALANCE_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '정산 브랜드 리스트 엑셀 다운로드 요청하기 실패',
};

export default BalanceToastMsg;
